import React from "react";
import { cn } from "../utils/cn";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "spec-ready" | "in-development" | "planned" | "deployed" | "default";
  size?: "sm" | "md" | "lg";
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = "default", size = "sm", children, ...props }, ref) => {
    // Design.md: border opacity 15-18%, background 3-6%, radius 14px, font 10.5px
    const variants = {
      "spec-ready":
        "border border-[rgba(77,183,247,0.16)] bg-[rgba(77,183,247,0.04)] text-[#4DB7F7]",
      "in-development":
        "border border-[rgba(61,231,208,0.16)] bg-[rgba(61,231,208,0.04)] text-[#3DE7D0]",
      planned:
        "border border-[rgba(255,255,255,0.15)] bg-[rgba(255,255,255,0.03)] text-[#A9B1BD]",
      deployed:
        "border border-[rgba(208,181,111,0.16)] bg-[rgba(208,181,111,0.04)] text-[#D0B56F]",
      default:
        "border border-thema-border bg-thema-surface/40 text-thema-text-soft",
    };

    const sizes = {
      sm: "h-[22px] px-3 text-[10.5px]",
      md: "h-6 px-3.5 text-xs",
      lg: "h-7 px-4 text-sm",
    };

    const statusLabels = {
      "spec-ready": "STATUS: ",
      "in-development": "STATUS: ",
      planned: "STATUS: ",
      deployed: "STATUS: ",
      default: "",
    };

    return (
      <span
        ref={ref}
        className={cn(
          "inline-flex items-center rounded-[14px] font-mono uppercase tracking-[0.14em] opacity-70",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {variant !== "default" && (
          <span className="opacity-50">{statusLabels[variant]}</span>
        )}
        {children}
      </span>
    );
  }
);

Badge.displayName = "Badge";

